import React from "react";
import { PencilSimple, Trash, MagnifyingGlass } from "@phosphor-icons/react";

// Admin list panel: filter input + counter header + scrollable rows
// with edit/delete actions. Pure presentational — the parent owns the
// items + filter state + handlers.
export default function PrayersAdminList({
    items, visibleItems, loading, filter, setFilter, onEdit, onDelete, t,
}) {
    return (
        <div className="mt-10" data-testid="prayers-admin-list-wrap">
            <div className="flex items-center justify-between flex-wrap gap-3 mb-3">
                <p className="label-eyebrow m-0">
                    {t("admin.stored_count", { count: items.length })}
                </p>
                <div className="relative w-full sm:w-64">
                    <MagnifyingGlass size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-stoneFaint" />
                    <input
                        type="search"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        placeholder={t("admin.filter_placeholder")}
                        data-testid="prayers-admin-filter"
                        className="w-full pl-7 pr-2.5 py-2 bg-white border border-sand-300 rounded-md ui-sans text-xs focus:outline-none focus:border-sangre"
                    />
                </div>
            </div>

            {loading ? (
                <p className="text-sm text-stoneMuted">{t("common.loading")}</p>
            ) : visibleItems.length === 0 ? (
                <p className="text-sm text-stoneMuted italic">
                    {filter ? t("admin.no_filter_matches") : t("admin.empty")}
                </p>
            ) : (
                <ul className="divide-y divide-sand-300 border border-sand-300 rounded-md overflow-hidden max-h-[420px] overflow-y-auto">
                    {visibleItems.map((p) => (
                        <li
                            key={p.id}
                            data-testid={`prayers-admin-row-${p.id}`}
                            className="flex items-start sm:items-center justify-between gap-3 p-3 sm:p-4 bg-white"
                        >
                            <div className="min-w-0 flex-1">
                                <p className="reading-serif text-base m-0 truncate" title={p.title}>{p.title}</p>
                                <p className="text-xs text-stoneMuted mt-0.5 truncate">
                                    {p.category}
                                    {p.source === "scraped" && (
                                        <span className="ml-2 ui-sans uppercase tracking-widest text-[10px] text-stoneFaint">
                                            {t("admin.imported_badge")}
                                        </span>
                                    )}
                                </p>
                            </div>
                            <div className="flex items-center gap-1 shrink-0">
                                <button
                                    type="button"
                                    onClick={() => onEdit(p)}
                                    data-testid={`prayers-admin-edit-${p.id}`}
                                    aria-label={t("admin.edit")}
                                    title={t("admin.edit")}
                                    className="p-2 text-stoneMuted hover:text-sangre hover:bg-sand-100 rounded-md transition-colors"
                                >
                                    <PencilSimple size={16} />
                                </button>
                                <button
                                    type="button"
                                    onClick={() => onDelete(p)}
                                    data-testid={`prayers-admin-delete-${p.id}`}
                                    aria-label={t("admin.delete")}
                                    title={t("admin.delete")}
                                    className="p-2 text-stoneMuted hover:text-sangre hover:bg-sand-100 rounded-md transition-colors"
                                >
                                    <Trash size={16} />
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
